import { createGetPropGetter } from '@/store/utils';

export default {
  apiKeys: createGetPropGetter('apiKeys', []),
  createdApiKey: createGetPropGetter('createdApiKey', {}),
};
